import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { CustomLoader } from '../../../../components/custom-loader';

const EmailVerifyView = ({ emailVerifyInfo, isFormSending, onEmailResend, isFormLoading }) => {
	if (isFormLoading) {
		return <CustomLoader />;
	}

	return (
		<div className="email-verify-view">
			<div className="email-verify-view__content">
				<div>
					<h2 className="email-verify-view__title email-verify-view__title_secondary">
						Подтверждение адреса
					</h2>
					<h2 className="email-verify-view__title email-verify-view__title_primary">электронной почты</h2>
				</div>
				<p className="email-verify-view__text">{emailVerifyInfo?.message}</p>
				<div className="email-verify-view__overlay" />
				{emailVerifyInfo?.button && (
					<Button
						onClick={onEmailResend}
						loading={isFormSending}
						disabled={isFormSending}
						primary
						className="email-verify-view__button"
					>
						{emailVerifyInfo?.button}
					</Button>
				)}
			</div>
		</div>
	);
};

EmailVerifyView.propTypes = {
	emailVerifyInfo: PropTypes.object,
	onEmailResend: PropTypes.func.isRequired,
	isFormSending: PropTypes.bool.isRequired,
	isFormLoading: PropTypes.bool.isRequired,
};

export { EmailVerifyView };
